export interface PlayerConfigurationDefinition {
  uuid?: string;
  name: string;
  displayName?:  string;
  description: string;
  editionMode: number;
  actionOnUpdate?: string;
  inputType: number;
  inputConstraint?: number;
  modelCompatibility?: string;
  consequence?: string;
  defaultValue?:  string;
  inputConstraintParam1?:  number;
  inputConstraintParam2?:  number;
  inputTypeOptions?: string;
  deleted?:  Date
  updated?:  Date;
  updatedBy?: string;
  created?:  Date;
  createdBy?:  string;
  id: number;
  isUsed?: boolean;
}

export enum EditionModes {
  'default',
  'No',
  'Yes',
  'Automatic'
}

export enum InputTypes {
  'default',
  'input',
  'checkBox',
  'number', // number
  'select',
  'time'
}

export enum InputConstraints {
  'default',
  'Range',
  'URL',
  'IP'
}

export enum ModelCompatibilities {
  'default',
  'All',
  'Video',
  'Audio',
  'PTL'
}



